var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90039 12.126V12.1924H6.09961V12.126H9.90039ZM11.7666 9.13965V9.20605H4.2334V9.13965H11.7666ZM13.6357 6.15234C13.6359 6.16563 13.6356 6.179 13.6357 6.19238C13.6359 6.20139 13.6366 6.21065 13.6367 6.21973H2.36621V6.15234H13.6357ZM15.5 3.16602V3.21484H0.5V3.16602H15.5Z",
    fill: "#275180",
    stroke: "#275180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.eb71cf4847b82b59784dfdf8dfca8442.svg";
export { ForwardRef as ReactComponent };